// @flow

//TODO: We're not using spritesheets at the moment, so this could all totally change. Really not sure yet.

//This is built in a way where the data could be extracted in a different file (like, if we need to load it)

// type skinSchema = {
//   frontViewSrc: "/path/to/front.svg",
//   backViewSrc: "/path/to/back.svg",
// };

const skins = {
  skin_mystery: {
    frontViewSrc: "/images/skins/mystery-front.svg",
    backViewSrc: "/images/skins/mystery-front.svg" //duplicate for now
  },

  skin_f1: {
    frontViewSrc: "/images/skins/f-1-front.svg",
    backViewSrc: "/images/skins/f-1-back.svg"
  },
  skin_f2: {
    frontViewSrc: "/images/skins/f-2-front.svg",
    backViewSrc: "/images/skins/f-2-back.svg"
  },
  skin_f3: {
    frontViewSrc: "/images/skins/f-3-front.svg",
    backViewSrc: "/images/skins/f-3-back.svg"
  },
  skin_m1: {
    frontViewSrc: "/images/skins/m-1-front.svg",
    backViewSrc: "/images/skins/m-1-back.svg"
  },
  skin_m2: {
    frontViewSrc: "/images/skins/m-2-front.svg",
    backViewSrc: "/images/skins/m-2-back.svg"
  },
  skin_m3: {
    frontViewSrc: "/images/skins/m-3-front.svg",
    backViewSrc: "/images/skins/m-3-back.svg"
  },
  skin_m4: {
    frontViewSrc: "/images/skins/m-4-front.svg",
    backViewSrc: "/images/skins/m-4-back.svg"
  },

  //BONUS:
  skin_bonus1: {
    frontViewSrc: "/images/skins/bonus1-front.svg", //TODO:
    backViewSrc: "/images/skins/bonus1-back.svg" //TODO:
  },
  skin_bonus2: {
    frontViewSrc: "/images/skins/bonus2-front.svg", //TODO:
    backViewSrc: "/images/skins/bonus2-back.svg" //TODO:
  }
}; //or EX: window.skinsLoadedFromElsewhere {}

//In any case, use this function to get the list of all possible skins
export default function() {
  return skins;
}



// WEBPACK FOOTER //
// ./src/_data/Skins.js